import { lazy, useEffect } from 'react';

// Step components
import Step0 from '../steps/Step0'; // Only Step0 is imported eagerly

// Lazily loaded components
const Step1 = lazy(() => import('../steps/Step1'));
const Step2 = lazy(() => import('../steps/Step2'));
const Step22 = lazy(() => import('../steps/Step22'));
const Step3 = lazy(() => import('../steps/Step3'));
const Step4 = lazy(() => import('../steps/Step4'));
const Step5 = lazy(() => import('../steps/Step5'));
const PreviousFundStep = lazy(() => import('../steps/PreviousFundStep'));
const Step6 = lazy(() => import('../steps/Step6'));
const Step7 = lazy(() => import('../steps/Step7'));
const Step8 = lazy(() => import('../steps/Step8'));
const Step9 = lazy(() => import('../steps/Step9'));
const ProductDetails = lazy(() => import('../Pages/ProductDetails'));
const ApplyPage = lazy(() => import('../Pages/ApplyPage'));

// Array of step components
export const stepComponents = [
  Step0,
  Step1,
  Step2,
  Step22,
  Step3,
  Step4,
  Step5,
  PreviousFundStep,
  Step6,
  Step7,
  Step8,
  Step9,
];

// Map for prefetching - associates each index with a module path to prefetch
const prefetchMap: Record<number, () => Promise<any>> = {
  0: () => import('../steps/Step1'),
  1: () => import('../steps/Step2'),
  2: () => import('../steps/Step22'),
  3: () => import('../steps/Step3'),
  4: () => import('../steps/Step4'),
  5: () => import('../steps/Step5'),
  6: () => import('../steps/PreviousFundStep'),
  7: () => import('../steps/Step6'),
  8: () => import('../steps/Step7'),
  9: () => import('../steps/Step8'),
  10: () => import('../steps/Step9'),
};

// Page components available separately
export const pageComponents = {
  ProductDetails,
  ApplyPage,
};

// Hook for prefetching
export const useStepLoading = (currentStep: number) => {
  useEffect(() => {
    // Prefetch the next step if available
    if (prefetchMap[currentStep]) {
      prefetchMap[currentStep]().catch(console.error);
    }
  }, [currentStep]);

  return {
    StepComponent: stepComponents[currentStep],
    LoadingFallback: () => (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    ),
  };
}; 